import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { getClaim } from "@/lib/claim";

export const FinishSignupBanner = () => {
  const [valid, setValid] = useState(false);
  const { pathname, search } = useLocation();

  useEffect(() => {
    let live = true;
    getClaim().then((c) => live && setValid(!!c));
    return () => { live = false; };
  }, [pathname]);

  if (!valid || (pathname === "/login" && search.includes("mode=register"))) return null;
  return (
    <>
    <div className="h-16" aria-hidden />
    <div className="fixed bottom-0 inset-x-0 z-40 mm-gradient text-white shadow-lg mm-fade-up" data-testid="finish-signup-banner">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-2.5 flex flex-wrap items-center justify-between gap-2 text-sm">
        <span className="flex items-center gap-2"><CheckCircle2 size={16} />You've paid — finish creating your account to unlock Mindful Me.</span>
        <Link to="/login?mode=register" className="bg-white text-mm-primary font-semibold rounded-full px-4 py-1.5 hover:scale-105 transition-transform" data-testid="finish-signup-cta">Finish sign-up</Link>
      </div>
    </div>
    </>
  );
};
